import posthog from 'posthog-js';
import type { User } from '../types';

const posthogKey = import.meta.env.VITE_POSTHOG_KEY?.trim();
const posthogHost =
  import.meta.env.VITE_POSTHOG_HOST?.trim() || 'https://us.i.posthog.com';

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    autocapture: false,
    capture_pageview: false, // we track pageviews manually via the router
  });
}

// --- Identity helpers ---

export function identifyUser(user: User) {
  if (!posthogKey) return;
  posthog.identify(user.id, {
    email: user.email,
    name: user.name,
  });
}

export function resetUser() {
  if (!posthogKey) return;
  posthog.reset();
}

// --- Event helpers ---

export function trackSearch(params: {
  location?: string;
  startDate?: string;
  nights?: number;
  guests?: number;
}) {
  if (!posthogKey) return;
  posthog.capture('search', params);
}

export function trackCreateRequest(facilityId: string) {
  if (!posthogKey) return;
  posthog.capture('create_request', { facilityId });
}

export function trackCancelRequest(requestId: number) {
  if (!posthogKey) return;
  posthog.capture('cancel_request', { requestId });
}

export function trackViewFacility(facilityId: string, name: string) {
  if (!posthogKey) return;
  posthog.capture('view_facility', { facilityId, name });
}

export function trackViewPark(parkId: string, name: string) {
  if (!posthogKey) return;
  posthog.capture('view_park', { parkId, name });
}

export { posthog };
